<template>
  <b-form>
    <!-- <span>Pilih Bidang Studi </span> -->
    <Select2 v-model="selectedValue" :options="options" @change="changeprodi($event)"
      :settings="{ multiple: false, width: '100%' }" :placeholder="placeholder" />
  </b-form>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      // selected: null,
      options: [
        { id: null, text: '--Pilih Prodi--' },
      ],
      dataLogin: JSON.parse(localStorage.getItem('dataLogin')),
    };
  },
  props: {
    changeprodi: Function,
    placeholder: String,
    selectedValue: String
  },
  components: {
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    async getData() {
      await axios.get('master/study-programs?status=t')
        .then(response => {
          if (response.status == 200) {
              const filteredData = response.data.data.filter(item => item.program_code !== "N001");
              filteredData.some((e, index) => {
              var object = { "id": e.key, "text": e.program_name }
              this.options.push(object);
              return index > e.length;
            });
          }
        })
    },
  },
  computed: {
    config() {
      let dataConfig = {
        headers: { Authotization: `Bearer ${this.dataLogin.access_token}`, 'content-Type': 'application/json' }
      }
      return dataConfig
    }
  }
}
</script>